module.exports = __webpack_public_path__ + "img/Procurement.d90f0a8f.png";